// import config from "@/api/config"
import ApiClient from '@/api/ApiClient'

// ApiClient.client().defaults.baseURL = config.mdhApiUrl

export default {
    /**
     * Send cookie consents
     *
     * @param {object} payload
     * @returns {Promise}
     */
    postCookieConsents(payload) {
        return ApiClient.post('/api_hub/cookie_consents', payload)
    },
}
